// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__Y5SZV","name":"navbar_name__KaKnp"};